import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Checkbox } from 'semantic-ui-react';
import { sortableHandle } from 'react-sortable-hoc';

import "./Subquestion.scss";

import { changeSubquestionVisibilityAsync } from "../../../../redux/actions/questionInfo";

const mapDispatchToProps = dispatch => ({
  onChangeVisibility: (status, questionId, questionIndex) => dispatch(changeSubquestionVisibilityAsync(status, questionId, questionIndex)),
});

const DragHandle = sortableHandle(() => <div className="points" />);

class Subquestion extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onChangeVisibility: PropTypes.func.isRequired,
  };

  render() {
    const { item, index, onChangeVisibility } = this.props;

    return (
      <div className="subq-item-main">
        <div className="subq-title-wrap">
          <div className="subq-item-title">{item.header}</div>
          <div className="subq-item-btns">
            <Checkbox
              label='Скрыть'
              checked={!item.is_visible}
              onChange={() => onChangeVisibility(!item.is_visible, item.id, index)} 
            />
              <DragHandle />
          </div>
        </div>
        <div className="subq-item-content">{item.answer}</div>
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(Subquestion);
